<template>
  <v-container>
    <v-row class="text-center" justify="center">
      <v-col cols="12">
        <p class="text-body-1">
          {{ $t('L_to_change_your_beneficiaries_first')
          }}<a
            href="javascript:void(0)"
            id="ny_doc_multi-purpose"
            @click="openDocument(formLinks['multiPurposeForm'], $t('L_multi_purpose_form'))"
            class="subheading font-weight-medium"
          >
            {{ $t('L_to_change_your_beneficiaries_multi_purpose_change_form') }} </a
          >{{ $t('L_to_change_your_beneficiaries_last') }}
        </p>
      </v-col>
      <EmbeddedViewer
        :title="document.title"
        :loading="document.loading"
        content-type="application/pdf"
        :content-url="document.content"
        @close="document.content = undefined"
      />
    </v-row>
    <v-row class="text-center" justify="center">
      <v-col cols="12">
        <p class="text-body-1">
          {{ $t('L_national_benefit_life_insurance_title') }}
        </p>
        <p class="text-body-1">
          {{ $t('L_national_benefit_life_insurance_address') }}
        </p>
        <p class="text-body-1">
          {{ $t('L_policy_submit_written_request_include_note') }}
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import EmbeddedViewer from '@/components/EmbeddedViewer.vue';
import { mapState } from 'pinia';
import { useGlobalStore } from '@/stores/global/global.store';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { FEATURE_FLAGS } from '@/shared/models/constants.models';

const componentOptions: ComponentOptions = {
  name: 'NYBeneficiaryCard',
  components: {
    EmbeddedViewer,
  },
  data: () => ({
    document: {
      title: '',
      content: '' as string | undefined,
      loading: false,
    },
  }),
  computed: {
    ...mapState(useGlobalStore, ['containsFeature', 'features']),
    ...mapState(usePolicyStore, {
      beneficiaries: 'beneficiaries',
      isPending: 'isPending',
    }),
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
    }),
    displayBeneficiaries() {
      return (
        this.containsFeature(FEATURE_FLAGS.BENEFICIARIES) &&
        this.beneficiaries &&
        this.beneficiaries?.length > 0
      );
    },
    formLinks() {
      if (this.locale === 'en_US') {
        return { ...window.appConfig.policyDocumentForms.en_NY };
      }
      return { ...window.appConfig.policyDocumentForms.es_NY };
    },
  },
  methods: {
    openDocument(content: string, title: string) {
      this.document.title = title;
      this.document.content = `${window.appConfig.content_stack}${content}`;
    },
  },
};

export default defineComponent(componentOptions);
</script>
